var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 50,
    viewBox: "0 0 82 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_399)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_458_399",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 83,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.191406 0H82.0096V49.0909H0.191406V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_458_399)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1005 0C30.1914 0 23.3732 5.45455 20.646 16.3636C24.7369 10.9091 29.5096 8.86364 34.9641 10.2273C38.0763 11.0045 40.3005 13.2636 42.7626 15.7621C46.7732 19.8333 51.4156 24.5455 61.555 24.5455C72.4641 24.5455 79.2823 19.0909 82.0096 8.18182C77.9187 13.6364 73.146 15.6818 67.6914 14.3182C64.5793 13.5409 62.355 11.2818 59.8929 8.78333C55.8823 4.71212 51.2399 0 41.1005 0ZM20.646 24.5455C9.73686 24.5455 2.91868 30 0.191406 40.9091C4.28232 35.4545 9.05504 33.4091 14.5096 34.7727C17.6217 35.5515 19.846 37.8091 22.3081 40.3076C26.3187 44.3788 30.9611 49.0909 41.1005 49.0909C52.0096 49.0909 58.8278 43.6364 61.555 32.7273C57.4641 38.1818 52.6914 40.2273 47.2369 38.8636C44.1247 38.0864 41.9005 35.8273 39.4384 33.3288C35.4278 29.2576 30.7853 24.5455 20.646 24.5455Z",
    fill: "#38BDF8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.8182,
    height: 50,
    fill: "white",
    transform: "translate(0.191406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.2b079cbe439ece257a0fc29b47682953.svg";
export { ForwardRef as ReactComponent };